<template>
  <div>
    <Head title="Bukti Potong" />
    <h1 class="mb-8 text-3xl font-bold">DAFTAR BUKTI PEMOTONGAN PAJAK PENGHASILAN PASAL 21 (TIDAK FINAL) DAN/ATAU PASAL 26</h1>
    <div class="flex items-center justify-between mb-6">
      <div class="flex">
        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Status:</label>
          <select v-model="form.status" class="form-select mt-1 w-full">
            <option :value="null" />
            <option value="1">Belum Dikirim</option>
            <option value="2">Sudah Dikirim</option>
            <option value="3">Gagal Dikirim</option>
          </select>
        </search-filter>
        <button class="btn-orange" @click="bulkSend()">
          <span>Send</span>
          <span class="hidden md:inline">&nbsp;Bulk Email</span>
        </button>
        <button class="btn-danger" @click="bulkDelete()">
          <span>Delete</span>
          <span class="hidden md:inline">&nbsp;Bulk</span>
        </button>
      </div>
      <Link class="btn-indigo" href="/import/ebupot-pph-21-tidak-final">
        <span>Import</span>
        <span class="hidden md:inline">&nbsp;Bukti Potong</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">
            <input v-model="selectAll" type="checkbox" @click="selectAllCheckBox()" />
          </th>
          <th v-for="(attr, idx) in attributes" :key="idx" class="pb-4 pt-6 px-6">{{ attr.label }}</th>
        </tr>
        <tr
          v-for="(val, idx) in data"
          :key="idx"
          class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t pb-4 pt-6 px-6">
            <input v-if="val.status === 1 || val.status === 3" v-model="checkedData" :value="val.id" type="checkbox" />
          </td>

          <td v-for="(attr, ids) in attributes" :key="ids+1" class="border-t">
            <Link
              v-if="attr.key === 'status_name'"
              class="flex items-center px-6 py-4"
              :href="`/ebupot-pph-21-tidak-final/${val.id}`"
              tabindex="-1"
            >
              <div v-html="val[attr.key]" />
            </Link>

            <Link
              v-else
              class="flex items-center px-6 py-4"
              :href="`/ebupot-pph-21-tidak-final/${val.id}`"
              tabindex="-1"
            >
              {{ val[attr.key] }}
            </Link>
          </td>

          <td class="w-px border-t">
            <Link
              class="flex items-center px-4"
              :href="`/ebupot-pph-21-tidak-final/${val.id}`"
              tabindex="-1"
            >
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No data found.</td>
        </tr>
      </table>
    </div>
    <!-- <pagination class="mt-6" :links="data.links" /> -->
  </div>
</template>

<script setup>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import pickBy from "lodash/pickBy";
import throttle from "lodash/throttle";
// import Pagination from "@/Shared/Pagination";
import SearchFilter from "@/Shared/SearchFilter";
import { reactive, ref, watch } from "vue";
import { Inertia } from "@inertiajs/inertia";

let props = defineProps({
  filters: Object,
  data: Object,
  attributes: Array,
});
const checkedData = ref([]);
const selectAll = ref(false);
let form = reactive({
  search: props.filters.search,
  status: props.filters.status,
});

watch(
  form,
  throttle(function () {
    Inertia.get("/ebupot-pph-21-tidak-final", pickBy(form), { preserveState: true });
  }, 300),
);

function selectAllCheckBox(){
  if(!selectAll.value){
    props.data.forEach(val => {
      if(val.status === 1 || val.status === 3){
        checkedData.value.push(val.id);
      }
    });
  }else{
    checkedData.value = [];
  }
}

function bulkSend(){
  Inertia.post("/bulk/ebupot-pph-21-tidak-final", {
    ids: checkedData.value,
  });
}


function bulkDelete(){
  Inertia.post("/bulk/ebupot-pph-21-tidak-final/delete", {
    ids: checkedData.value,
  });
}

function reset() {
  form.search = null;
  form.status = null;
}
</script>
